import { render, staticRenderFns } from "./customSuccessSlider.vue?vue&type=template&id=0c55dba6"
import script from "./customSuccessSlider.vue?vue&type=script&lang=js"
export * from "./customSuccessSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports